<template>
    <section class="ui-details">
        <ui-headline v-if="title">{{ title }}</ui-headline>
        <section class="ui-details-meta">
            <section class="ui-details-coversection">
                <div v-if="cover" :class="['ui-details-cover', image ? 'has-image' : '']" :style="coverStyle"></div>
            </section>
            <ul class="ui-details-list">
                <li :class="['ui-details-list__item', size, item === 'break' ? 'break' : '']" v-for="(item, index) in list" :key="index">
                    <template v-if="item !== 'break'">
                        <div class="ui-details-list__item__label">{{ item.label }}</div>
                        <div class="ui-details-list__item__value">
                            <template v-if="Array.isArray(item.value)">
                                <div v-for="text in item.value">{{ text }}</div>
                            </template>
                            <template v-else>
                                <template v-if="item.isLink || item.onClick">
                                    <ui-link @click="item.onClick">{{ item.value }}</ui-link>
                                </template>
                                <template v-else>
                                    {{ item.value }}
                                </template>
                            </template>
                        </div>
                    </template>
                </li>
            </ul>
        </section>
    </section>
</template>

<script>
    export default {
        name: 'ui-details',
        props: ['title', 'cover', 'list', 'image', 'size'],
        computed: {
            coverStyle() {
                if (this.image) {
                    return {
                        'background-image': 'url('+ this.image +')',
                    };
                }

                return false;
            },
        },
    };
</script>

<style>

.ui-details{
    padding:10px;
}
.ui-details.no-padding {
    padding:0;
}

.ui-details-cover{
    width:170px;
    height:230px;
    background-color: grey;
    margin: 0 25px 25px 0px;
}

.ui-details-cover.has-image {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-repeat: no-repeat;
}


.ui-details-coversection{
    display:flex;
    justify-content: flex-start;
}

.ui-details-meta{
    display:flex;
    flex-direction:row;
    /*margin-bottom: 15px;*/
}

.ui-details-list{
    display:flex;
    flex-wrap: wrap;
    margin-bottom:0px;
    width: 100%;
}

.ui-details-list__item{
      flex: 1 0 50%;
}

.ui-details-list__item.break {
    flex: 0 0 100% !important;
}

.ui-details-headline {
    font-weight:600;
    font-size: 1.28em;
    line-height:1.5em;
    margin: 0px 0px 0px 0px;
    letter-spacing: 0.02em;
    /*color:rgba(0,0,0,0.9);*/
}

.ui-details-list__item__label{
    font-weight:400;
    color:rgba(0,0,0,0.5);
    /*margin-top:15px;*/
    margin-bottom: 4px;
    /*white-space: normal;*/
}

.ui-details-list__item__value{
    white-space: normal;
    margin-bottom: 20px;
    padding-right: 10px;
}

/**
 * Sizing
 */

    .ui-details-list__item.w250 {
        flex: 0 0 250px;
    }

    .ui-details-list__item.p25 {
        flex: 0 0 25%;
    }

</style>



// WEBPACK FOOTER //
// UiDetails.vue?1b566548